<template>
<footer id="footer">
    <div v-if="$route.path == '/'" class="section interests" :style="'background-image: url(' + site_data.siteconfig.footer_hero.url + ');'">
        <div class="container has-text-centered">
            <header class="section-header in-footer">
                <h2 class="title is-2 has-text-white">Interests</h2>
                <span><i></i><i></i><i></i></span>
            </header>
            <div class="columns is-variable is-multiline is-8 is-mobile">
                <div :class="'column is-' + col_size">
                    <p><img src="@/assets/coding.svg" /></p>
                    <p class="title is-6">Coding</p>
                    <p class="subtitle">Days &amp; nights</p>
                </div>
                <div :class="'column is-' + col_size">
                    <p><img src="@/assets/running.svg" /></p>
                    <p class="title is-6">Running</p>
                    <p class="subtitle">Commute solution</p>
                </div>
                <div :class="'column is-' + col_size">
                    <p><img src="@/assets/gym.svg" /></p>
                    <p class="title is-6">Gyms</p>
                    <p class="subtitle">Before bedtime</p>
                </div>
                <div :class="'column is-' + col_size">
                    <p><img src="@/assets/hiking.svg" /></p>
                    <p class="title is-6">Hiking</p>
                    <p class="subtitle">On the weekends</p>
                </div>
            </div>
        </div>
    </div>
    <div class="footer">
        <div class="container has-text-centered ">
            <p class="content social" v-if="site_data.siteconfig.socials">
                <a :href="item.url" target="_blank" v-for="item in site_data.siteconfig.socials">
                    <span class="icon"><i :class="'fab fa-' + item.id"></i></span>
                </a>
            </p>
            <div class="copyright">© {{year}} {{site_data.siteconfig.title}}</div>
        </div>
    </div>
</footer>
</template>

<script>
export default {
    name: 'Footer',
    props: [
        'site_data'
    ],
    data: function() {
        return {
            col_size    :   3
        };
    },
    mounted()
    {
        this.$bus.$on('onWindowSize', this.handle_resize);
    },
    beforeDestroy()
    {
        this.$bus.$off('onWindowSize', this.handle_resize);
    },
    methods :   {
        handle_resize(width)
        {
            if (width <= 600) {
                if (width <= 480) {
                    this.col_size   =   12;
                } else {
                    this.col_size   =   6;
                }
            } else {
                this.col_size   =   3;
            }
        }
    },
    components: {},
    watch: {

    },
    computed: {
        year() {
            let d = new Date();

            return d.getFullYear();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/Footer.vue